export const STATUS_COLORS = Object.freeze({
  BLUE: "blue",
  RED: "#B72025",
  GREEN: "#69A042",
  GREY: "#C8C8C8",
  YELLOW: "#ffa31a",
  TRANSPARENT: "transparent",
  DARK_BLUE: "#426BA6",
});
